import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__section">
            <div className="footer__logo">
              <span className="logo-icon">AI</span>
              <span className="logo-text">AICraft</span>
            </div>
            <p className="footer__description">
              使用最先进的 AI 技术，为您的创意和业务提供专业服务
            </p>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">产品</h4>
            <ul className="footer__links">
              <li><a href="#services">AI 绘图定制</a></li>
              <li><a href="#services">AI 写作服务</a></li>
              <li><a href="#services">AI Logo 生成</a></li>
              <li><a href="#pricing">定价方案</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">公司</h4>
            <ul className="footer__links">
              <li><a href="#about">关于我们</a></li>
              <li><a href="#blog">博客</a></li>
              <li><a href="#careers">招聘</a></li>
              <li><a href="#contact">联系我们</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">支持</h4>
            <ul className="footer__links">
              <li><a href="#help">帮助中心</a></li>
              <li><a href="#docs">API 文档</a></li>
              <li><a href="#terms">服务条款</a></li>
              <li><a href="#privacy">隐私政策</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © 2024 AICraft. 保留所有权利。
          </p>
          <div className="footer__social">
            <a href="#" aria-label="Twitter">🐦</a>
            <a href="#" aria-label="GitHub">💻</a>
            <a href="#" aria-label="LinkedIn">💼</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

